import { FC } from 'react';
import MuiAccordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ArrowUp from 'components/icons/ArrowUp';
import ArrowRight from 'components/icons/ArrowRight';

import { colorConstants } from 'data/constants';
import { SxProps, Theme } from '@mui/material';

interface IFaqAccordion {
  expanded: boolean;
  handleChange: (id: string) => void;
  title: string;
  text?: string | React.ReactNode;
  id: string;
  sx?: SxProps<Theme>;
}

const FaqAccordion: FC<IFaqAccordion> = ({
  expanded,
  handleChange,
  title,
  text,
  id,
  sx,
}) => {
  return (
    <MuiAccordion
      expanded={expanded}
      disableGutters
      elevation={0}
      onChange={() => handleChange(id)}
      sx={{
        border: 'none',
        ':before': {
          backgroundColor: colorConstants.brandColor,
        },
        ...sx,
      }}
    >
      <AccordionSummary
        aria-controls={`${id}`}
        id={`${id}`}
        expandIcon={expanded ? <ArrowUp /> : <ArrowRight />}
      >
        <div className="faq-title">{title}</div>
      </AccordionSummary>
      <AccordionDetails>
        <div className="accordion-container">
          <div className="accordion-container__left">
            {text && <div className="accordion-content">{text}</div>}
          </div>
        </div>
      </AccordionDetails>
    </MuiAccordion>
  );
};

export default FaqAccordion;
